import React from 'react'
import Caution from '../../../../assets/icon/caution.svg'

export default function NameVerificationModal({ isOpen, onClose, onContinue }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-[rgba(254,235,221,1)] w-[480px] h-[452px] rounded-[12px] border border-orange-200 p-6 flex flex-col justify-between items-center text-center shadow-lg">
        {/* Top content */}
        <div className="flex flex-col items-center gap-6">
          {/* Icon */}
          <div className="mx-auto w-[88px] h-[77px] flex items-center justify-center">
            <img src={Caution} alt="caution" />
          </div>

          {/* Text */}
          <h2 className="font-inter font-bold text-[20px] leading-[32px] text-center">
            Verify Your Name and Last Name
          </h2>
          <p className="font-inter font-medium text-[14px] leading-[20px] text-center">
            Please ensure that the name and last name you enter match exactly as they appear on your
            official ID.
            <br />
            <br />
            These details cannot be changed after creating your account. Mismatched names will cause
            your KYC verification to fail, which may delay or prevent you from accessing the
            platform.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3 mt-4">
          <button
            onClick={onClose}
            className="w-[372px] h-[44px] px-4 py-[7px] rounded-[8px] gap-3 flex items-center justify-center text-white font-medium opacity-100"
            style={{ background: 'rgba(247,144,9,1)' }}
          >
            Edit Information
          </button>
          <button
            onClick={onContinue}
            type="submit"
            className="w-[372px] h-[44px] px-4 py-[7px] rounded-[8px] gap-3 flex items-center justify-center text-[rgba(247,144,9,1)] font-medium opacity-100"
            style={{ background: 'white' }}
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  )
}
